import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=22745e88&scoped=true"
import script from "./RadioInput.vue?vue&type=script&lang=js"
export * from "./RadioInput.vue?vue&type=script&lang=js"
import style0 from "./RadioInput.vue?vue&type=style&index=0&id=22745e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22745e88",
  null
  
)

export default component.exports